
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqsd1W6tNONwJrGs_gY9n_aq1Tbwy_45Lvw7Egqr3yFLvEcMeta } from "/codebuild/output/src3798805888/src/src/pages/faq.vue?macro=true";
import { default as menutVDQ7GNMBKy0nGg2gtb2NXzDrg_45xU064OaP_9If9VAQMeta } from "/codebuild/output/src3798805888/src/src/pages/menu.vue?macro=true";
import { default as indexzB1Y3jH_KHdvMDdCPqDzT_DrnKAgyPI5yR2xmeDpcLEMeta } from "/codebuild/output/src3798805888/src/src/pages/index.vue?macro=true";
import { default as contactx4jQRXltiwbqa8ekiLrISOFsome7_vYnaPLzaRIwsqkMeta } from "/codebuild/output/src3798805888/src/src/pages/contact.vue?macro=true";
import { default as tutorial3jRagezQCQwVvAAflk3_45t51Dgu8fbF9cwxX1FgJIumQMeta } from "/codebuild/output/src3798805888/src/src/pages/tutorial.vue?macro=true";
import { default as agreementie4_LCb3iNQLO6YMSoXn8fXWg5Ulo_7HlZqgCu74sCQMeta } from "/codebuild/output/src3798805888/src/src/pages/agreement.vue?macro=true";
import { default as about_45passeKETzP6qbGntiLXnZvImtfezQF9AHAMx9HsAYAojDpYMeta } from "/codebuild/output/src3798805888/src/src/pages/about-pass.vue?macro=true";
import { default as index0Nd5Er8U9b8H7fKGKGPVwiQPErj5aDjtXJ7VxggxUZYMeta } from "/codebuild/output/src3798805888/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93C6Ew74VgFGujyGYEi8wTy1JI25IIpSvg3pCIAERoimgMeta } from "/codebuild/output/src3798805888/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance02RDmzIDwX4aOfhqFoC01aIlyS_45_A1cTVufI_45_45v57_MMeta } from "/codebuild/output/src3798805888/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93dvWpfMBS38meRhfYRq1nnucDqcvkUO9TaIHGDUrRqNcMeta } from "/codebuild/output/src3798805888/src/src/pages/notice/[id].vue?macro=true";
import { default as index9CtvdR3OeXGzqy1aKmpVwHyVeMBY6RA7ufdx7XJyuecMeta } from "/codebuild/output/src3798805888/src/src/pages/coupon/index.vue?macro=true";
import { default as indexd4hKbmFXudA6yZwMbFdVrA2faILA_7zjiiDqEB2Js4UMeta } from "/codebuild/output/src3798805888/src/src/pages/mypage/index.vue?macro=true";
import { default as indext1eQ8MKg0YcqUQEZCseqHsbHdovEEgHfOFCc_45CiQMlAMeta } from "/codebuild/output/src3798805888/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93f_45CziFOgYKqTjub9cWAkFlF7RuHW2_45adKX7Dx0JQSYEMeta } from "/codebuild/output/src3798805888/src/src/pages/parking/[id].vue?macro=true";
import { default as indexX_nGXmkIoCn5bD0Q0k8qE95kFbiukhfPCa11bpDoU7QMeta } from "/codebuild/output/src3798805888/src/src/pages/history/index.vue?macro=true";
import { default as indexnWZClucw7RRbBBhv7fi1DX1zuCZS0aHZ_GFt56HubHAMeta } from "/codebuild/output/src3798805888/src/src/pages/monthly/index.vue?macro=true";
import { default as indexIjsw7hwXXYhf0smbrVwiB011azWKohagsvQZG2jKKhMMeta } from "/codebuild/output/src3798805888/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexHw_45QYLT1RfqglSj0uCZGG3d966s0SNerYr22AbtSlHEMeta } from "/codebuild/output/src3798805888/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviOO1OHB29fuLywZtZMj_UsMsbhB_xM4GbMHt_45TupCRAMMeta } from "/codebuild/output/src3798805888/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editgn400AgJcZsv9HAOxxDowCPS_JlYVGuCusXCc8iJyWgMeta } from "/codebuild/output/src3798805888/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementBpxaBpFrlF0f76kuLw2QTA3pe2JmhdkhEm2WI_dFBeAMeta } from "/codebuild/output/src3798805888/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexc0JPiQEhhGELXc1cFSE2OGAv6T9OEAbyw__RdzuSLy8Meta } from "/codebuild/output/src3798805888/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453db__3o6oKibsUd3A2NnEyG_uTdehtXCda4HExF0u33Z4Meta } from "/codebuild/output/src3798805888/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmIOm2toTuyc6mP_8FIvJjrsp62Whocng0fS_45KIlbot9gMeta } from "/codebuild/output/src3798805888/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as index7taMhUGW1b5iyNVIRizNXmk6KxTJ5gftSp1Uyy2W4r8Meta } from "/codebuild/output/src3798805888/src/src/pages/card/create/index.vue?macro=true";
import { default as index_SUMI1NYOuNvGhyg5ArP_45JfSMp_Fqk9Gd_bO0bIEtAcMeta } from "/codebuild/output/src3798805888/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmOlhI_45Z_7CivOhC_45ENgj5HwTVDm4IS8DtgTt_dS62BcQMeta } from "/codebuild/output/src3798805888/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmlr3ZJ_45U4CvuGmhhC6MWHOq89xHNzZhSsoGAGmECxQ4MMeta } from "/codebuild/output/src3798805888/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete_45Y9tezmLcI9mN7meI_45_fJTtHlMhn7djfInDkWFrzhMUMeta } from "/codebuild/output/src3798805888/src/src/pages/membership/complete.vue?macro=true";
import { default as registerTYxx6_45l6OzWOqj47PpaD1N9_CnJWuTyKkqusphmVSngMeta } from "/codebuild/output/src3798805888/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_938HZKJU3N46K7yQQyNnFeA2n0JFMwGDBYtJWh9xCtctAMeta } from "/codebuild/output/src3798805888/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmC_45Fol4d4WbYk_zeSBR9LFCFzNMQYAhieutZbellM02wMeta } from "/codebuild/output/src3798805888/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93DwvNNQW6WFmPDMcUm33APC5qW74miLGSZTtke7caPN8Meta } from "/codebuild/output/src3798805888/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexkeOE3ZGNbXxCtokJrUZhII6A3gB0fSMl9m2xLJVAZogMeta } from "/codebuild/output/src3798805888/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeYyXy6cRXu26XUMt0fQwgkJL7rscdE7DLQZ5y2aAROhUMeta } from "/codebuild/output/src3798805888/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeg8QoYiMz3N5gda8wluLlNpYjgMXckx_451_i7ZWqZWu3YMeta } from "/codebuild/output/src3798805888/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeJKHmvNL8ix9hYYreijq1NJbCqBTNCVgf0ZcYr5MmccYMeta } from "/codebuild/output/src3798805888/src/src/pages/contact-form/complete.vue?macro=true";
import { default as register92dsH4CzTpHV4m9A1ouffzFC9ROfnpxm6ZQdi26odSUMeta } from "/codebuild/output/src3798805888/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeOp0CxnyNf6BNKjLjJx_A8W_45JmWRY7WHYpl6Kt4LazZYMeta } from "/codebuild/output/src3798805888/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexmoHKUvqnbFGCUUiQVBaQznYS9f5ifLBOwHMVkMQaVxIMeta } from "/codebuild/output/src3798805888/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmQyyWdJaOs1rzdhY3nB7fnLJLcYwQyjsUJKASzh3lwwUMeta } from "/codebuild/output/src3798805888/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeF9EDbLjY48HPYq_45f6e4XluMdUeThfhlsZtAppzYSELkMeta } from "/codebuild/output/src3798805888/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexY1jNoGI0GY5bkKgoLemof9e7hyX1Y5d8dkrmkEzUYzsMeta } from "/codebuild/output/src3798805888/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93dQa6ScWzLRMI3rnI2wva4DUlK4Nwz3Rs5sZNsHPz_REMeta } from "/codebuild/output/src3798805888/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete_45jNQVbEInX9oHPNsIhGe4nax0nKFTYA_451qZb6MAW9pEMeta } from "/codebuild/output/src3798805888/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasYQ_45jKJfru2A_UjUSIuZjA4t1cLk2JpjqZvbtldRIn6sMeta } from "/codebuild/output/src3798805888/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplelMVHOcdIOEtHrFMTgsdcUl0_453BdEhYFnj7yWWAXekakMeta } from "/codebuild/output/src3798805888/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45email6Bnm9JccWJ2DqHl62CLq4bllGa1f8gJh6FfjWnTUPGQMeta } from "/codebuild/output/src3798805888/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmMT3vxSOnz_450DezrlopcEuT8tVlfLkQijQM4HxAdLGvcMeta } from "/codebuild/output/src3798805888/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentUmgI5et3GN8ZG4cykHZWb3J0Po7Pe_aqVGferx8kQ_454Meta } from "/codebuild/output/src3798805888/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmzFMKJyFD3M4mWgvnUmFoCiNhlSSSx9FWsKKtehT11VgMeta } from "/codebuild/output/src3798805888/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateu6qigpCMLzh8es35K7t_45IlYJaXjjU0B4mCHTxPiBgX8Meta } from "/codebuild/output/src3798805888/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeNa2pid3K382ixstSXfiutVQunp4I_45_45ghmqibi0_4571_cMeta } from "/codebuild/output/src3798805888/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeYVzUw0hAYmZtEgxYq9TWnYui_455A__Ql_yoZj6u74jAoMeta } from "/codebuild/output/src3798805888/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordJCVD_45jineYCrTFGVeg0JBCh_2TxZmGGITEqI4V_45rGwAMeta } from "/codebuild/output/src3798805888/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45alias5u36u06srKVllP_45xDbLYyt2zDilhMUrwFGOScrCQIVEMeta } from "/codebuild/output/src3798805888/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register00vRMOA3kZFvrw1fcy2_45OALhRfMcjZCqX2BmTgcLOUIMeta } from "/codebuild/output/src3798805888/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codesvQTWkRTdoYHwAdVeOW1smsZUlIaZpmigzu9GFhknrMMeta } from "/codebuild/output/src3798805888/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index8JGpcToL2hmcIKHl7yjkvoRbX468d9jG3iI_gU6CEZMMeta } from "/codebuild/output/src3798805888/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexmsqls_SG5hRH1v4wWgOWAWavxNcH6LagH5xcYZvVddQMeta } from "/codebuild/output/src3798805888/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexF4aI7iksiW1lhkmuYmMpcNvT0CExED1b5UNJmZtnOJsMeta } from "/codebuild/output/src3798805888/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexogmJCdWR2A7gzWUyN5C7ztwdg3DUGF4tl06QoFHdqIkMeta } from "/codebuild/output/src3798805888/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatertW5_7HsRR3_DMMD_458F6hP2nCRrAQm7L8guJlRRTeB8Meta } from "/codebuild/output/src3798805888/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completei8pT70mThW3OurwwQm0ViOo2AfSqDdPgee7o245stqUMeta } from "/codebuild/output/src3798805888/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmaM1DzXsQwHyFfh9zd3e5ctmtfTkvxe9o6vTXUAzDMy4Meta } from "/codebuild/output/src3798805888/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as index6orGL_rvAfkQCTwDxtw6FHOGXEJOUWYEY5Y9y18cgBUMeta } from "/codebuild/output/src3798805888/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completefnsjJkR2vCcKDfYziPjTxsK_45pwUmu_45i2ZtgjUtqO3zUMeta } from "/codebuild/output/src3798805888/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateqocMhdOYFd22o5umkNtayKjmnv6II4ZbBAu2mvHSv78Meta } from "/codebuild/output/src3798805888/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexTiVYS21gDl9DMzzU3mmaOK_45kfC3oi9o9lUSliajk78wMeta } from "/codebuild/output/src3798805888/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexghVuD15BeU9uYErCkS_z6zyhUGgrvJ2mKQ_LbRTlk4YMeta } from "/codebuild/output/src3798805888/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completejxOAZGSzykeD_45KB74iROfafO_3f10LI2D_sCxsEwGNYMeta } from "/codebuild/output/src3798805888/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexz8vqAS82z7YiNnNxSRCvk32pcvFYG_HNMkfhQ7bmuAAMeta } from "/codebuild/output/src3798805888/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code4mRmJ4Zd_hTI4kM6AMK2m9BORX8iahIUuGxsq50yUEsMeta } from "/codebuild/output/src3798805888/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexQzji5UKnLEVC1Ovh_45G3Ha14_455MgifFkLbY0ueHk4Nv4Meta } from "/codebuild/output/src3798805888/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexU0YXQSiqeAQMbuw_45lm55Vucf0V_4574i1LQxHgsP_aGSUMeta } from "/codebuild/output/src3798805888/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexPjSLz2WVhiQHWj63_6byxpSbdzjjXvXGLp7l6OQ5rwwMeta } from "/codebuild/output/src3798805888/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateOXOPvHPbcqxibywPhuVkkmsxisKcqvtzNsu6YaMpC4MMeta } from "/codebuild/output/src3798805888/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmDDRgO0dw6sbz5MJfgX_rUMI7yC_7N1yb7qBXUOFJ8u0Meta } from "/codebuild/output/src3798805888/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menutVDQ7GNMBKy0nGg2gtb2NXzDrg_45xU064OaP_9If9VAQMeta || {},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexzB1Y3jH_KHdvMDdCPqDzT_DrnKAgyPI5yR2xmeDpcLEMeta || {},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index9CtvdR3OeXGzqy1aKmpVwHyVeMBY6RA7ufdx7XJyuecMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3798805888/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexX_nGXmkIoCn5bD0Q0k8qE95kFbiukhfPCa11bpDoU7QMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3798805888/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexIjsw7hwXXYhf0smbrVwiB011azWKohagsvQZG2jKKhMMeta || {},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexHw_45QYLT1RfqglSj0uCZGG3d966s0SNerYr22AbtSlHEMeta || {},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: index7taMhUGW1b5iyNVIRizNXmk6KxTJ5gftSp1Uyy2W4r8Meta || {},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmOlhI_45Z_7CivOhC_45ENgj5HwTVDm4IS8DtgTt_dS62BcQMeta || {},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmlr3ZJ_45U4CvuGmhhC6MWHOq89xHNzZhSsoGAGmECxQ4MMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3798805888/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete_45Y9tezmLcI9mN7meI_45_fJTtHlMhn7djfInDkWFrzhMUMeta || {},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerTYxx6_45l6OzWOqj47PpaD1N9_CnJWuTyKkqusphmVSngMeta || {},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmC_45Fol4d4WbYk_zeSBR9LFCFzNMQYAhieutZbellM02wMeta || {},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeYyXy6cRXu26XUMt0fQwgkJL7rscdE7DLQZ5y2aAROhUMeta || {},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeg8QoYiMz3N5gda8wluLlNpYjgMXckx_451_i7ZWqZWu3YMeta || {},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeJKHmvNL8ix9hYYreijq1NJbCqBTNCVgf0ZcYr5MmccYMeta || {},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: register92dsH4CzTpHV4m9A1ouffzFC9ROfnpxm6ZQdi26odSUMeta || {},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmQyyWdJaOs1rzdhY3nB7fnLJLcYwQyjsUJKASzh3lwwUMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeF9EDbLjY48HPYq_45f6e4XluMdUeThfhlsZtAppzYSELkMeta || {},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexY1jNoGI0GY5bkKgoLemof9e7hyX1Y5d8dkrmkEzUYzsMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete_45jNQVbEInX9oHPNsIhGe4nax0nKFTYA_451qZb6MAW9pEMeta || {},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplelMVHOcdIOEtHrFMTgsdcUl0_453BdEhYFnj7yWWAXekakMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45email6Bnm9JccWJ2DqHl62CLq4bllGa1f8gJh6FfjWnTUPGQMeta || {},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmMT3vxSOnz_450DezrlopcEuT8tVlfLkQijQM4HxAdLGvcMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentUmgI5et3GN8ZG4cykHZWb3J0Po7Pe_aqVGferx8kQ_454Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmzFMKJyFD3M4mWgvnUmFoCiNhlSSSx9FWsKKtehT11VgMeta || {},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeNa2pid3K382ixstSXfiutVQunp4I_45_45ghmqibi0_4571_cMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeYVzUw0hAYmZtEgxYq9TWnYui_455A__Ql_yoZj6u74jAoMeta || {},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordJCVD_45jineYCrTFGVeg0JBCh_2TxZmGGITEqI4V_45rGwAMeta || {},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register00vRMOA3kZFvrw1fcy2_45OALhRfMcjZCqX2BmTgcLOUIMeta || {},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codesvQTWkRTdoYHwAdVeOW1smsZUlIaZpmigzu9GFhknrMMeta || {},
    component: () => import("/codebuild/output/src3798805888/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3798805888/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]